import React, { useState, useEffect, useMemo } from 'react';
import { KeyboardAvoidingView, ScrollView, TouchableOpacity, View } from 'react-native'

import tw from '../../../../../styles/tailwind';
import Text from '../../../../../components/Text';
import Icon from '../../../../../components/IcomoonIcon';
import { useController, useForm, useWatch } from 'react-hook-form';
import { FooterButtons, TabsSelector } from '../NewGuestPassModal';
import Input from '../../../../../components/Forms/Input';
import DateSelector from '../../../../../components/Forms/DateSelector';
import IconButton from '../../../../../components/IconButton';
import dayjs from 'dayjs';


function GuestNameInput({ canDelete, onDeletePressed, onChange, value }){
  return (
    <View style={tw``}>
      <Input
        uncontrolled
        value={value}
        onChangeText={onChange}
        style={{
          container: tw`mb-0`,
          subcontainer: `bg-white border border-primary-200`,
          input: `text-primary-800`
        }}
        placeholder='Nombre completo'
      />
      
      {
        canDelete &&
          <TouchableOpacity style={tw`p-3 absolute right-1 top-0.5`} onPress={onDeletePressed}>
            <Icon name={"close"} style={tw``} color={'red'} size={24} />
          </TouchableOpacity>
      }
    </View>
  )
}


export default function EventGuestsStep({ control, name, setValue, onNextPressed, onBackPressed }) {
  const { field, fieldState: { invalid, isTouched, isDirty, error }, formState } = useController({
    control,
    name,
    rules: { required: true }
  })

  const [guests, setGuests] = useState([""]);
  const [isValid, setIsValid] = useState(false);

  useEffect(() => {
    setIsValid(guests.some(e => e?.length > 5))

  }, [guests]);


  const entry_date = useWatch({
    control,
    name: "entry_date",
  })

  let entryDateStr = ""

  if (entry_date) {
    const entryDate = dayjs(entry_date)
    if (entryDate.isToday()) {
      entryDateStr = "Hoy"
    } else if (entryDate.isTomorrow()) {
      entryDateStr = "Mañana"
    } else {
      entryDateStr = entryDate.format('ddd D MMM YYYY')
    }
  }

  function deleteGuest(index){
    const newArray = [...guests]
    newArray.splice(index, 1)
    setGuests(newArray)
  }

  function addNewGuest(){
    const newArray = [...guests, ""]
    setGuests(newArray)
  }

  function onGuestChanged(index, value){
    const newArray = [...guests]
    newArray[index] = value
    
    setGuests(newArray)
  }

  function _onNextPressed(){
    // onNextPressed()
    const value = guests.filter(e => e.length > 0)
    field.onChange(value)
    onNextPressed()
  }


 

  return (
    <>
      <ScrollView style={tw`flex-1`} keyboardShouldPersistTaps='handled'>
          <Text style={tw`text-white text-center text-xl font-500 mb-8`}>¿Cuándo es tu reunión?</Text>

          {/* 
            Selector fecha evento
          */}
          <View style={tw`row justify-between bg-white rounded-xl border border-primary-300 pl-6 pr-4 py-4`}>
            <Text style={tw`text-gray-600 font-500`}>Fecha</Text>

            <View style={tw`row`}>
              <Text style={tw`text-gray-600 font-500 text-lg mr-2 text-secondary`}>{entryDateStr}</Text>

              <Icon name='chevron-right' size={12} style={tw`-mt-1`} color={tw.color('secondary')} />
            </View>

            {/* Input oculto */}
            <View style={tw`mb-0 absolute left-0 right-0 top-0 bottom-0`}>
              <DateSelector
                style={tw`mb-0 h-100% opacity-2`}
                minimumDate={new Date(Date.now())}
                control={control}
                name="entry_date"
                rules={{ required: true }}
              />
            </View>
          </View>


          <Text style={tw`text-white text-center text-xl font-500 mt-8 mb-8`}>Puedes agregar una lista de invitados</Text>


          {/* 
            Lista invitados
          */}
          <View style={tw`bg-primary-100 rounded-2xl px-4 py-4 gap-y-4`}>
            {
              guests.map((guest, i) => 
                <GuestNameInput
                  key={i}
                  value={guest}
                  // canDelete={i < guests.length - 1}
                  canDelete={guests.length > 1}
                  onDeletePressed={() => deleteGuest(i)}
                  onChange={(text) => onGuestChanged(i, text)}
                />
              )
            }

            <IconButton
              title={'Agregar invitado'}
              style={tw`self-end py-3.5 px-7`}
              iconPosition='right'
              color='primary-800'
              onPress={addNewGuest}
            />
          </View>
      </ScrollView>

      <FooterButtons
        onBackPressed={onBackPressed}
        onNextPressed={_onNextPressed}
        nextDisabled={!isValid}
      />
    </>
  )
}